<template>
  <div class="note-template-department-select">
    <b-form-radio-group
      :checked="scope"
      :options="scopeOptions"
      :disabled="disabled"
      name="note-template-department-scope"
      stacked
      data-testid="note-template-department-scope"
      @change="onChangeScope" />
    <div
      v-if="!isAllDepartments"
      class="note-template-department-select__departments">
      <b-form-checkbox-group
        v-if="departmentOptions.length > 0"
        :checked="departments"
        :options="checkboxOptions"
        :disabled="disabled"
        name="note-template-departments"
        class="note-template-department-select__checkboxes"
        data-testid="note-template-department-checkboxes"
        @change="onChangeDepartments" />
      <p
        v-else
        class="fs-s mb-0">
        選択できるグループがありません
      </p>
    </div>
    <p
      v-if="disabled"
      class="note-template-department-select__lock-message fs-s mb-0"
      data-testid="note-template-department-lock-message">
      このテンプレートには閲覧権限のないグループが含まれているため、グループを変更できません。
    </p>
  </div>
</template>

<script>
const SCOPE_ALL = 'all'
const SCOPE_SELECTED = 'selected'

export default {
  name: 'NoteTemplateDepartmentSelect',
  props: {
    isAllDepartments: {
      type: Boolean,
      default: false
    },
    departments: {
      type: Array,
      default: () => []
    },
    departmentOptions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scopeOptions: [
        { text: 'すべてのグループ', value: SCOPE_ALL },
        { text: '個別グループ', value: SCOPE_SELECTED }
      ]
    }
  },
  computed: {
    scope() {
      return this.isAllDepartments ? SCOPE_ALL : SCOPE_SELECTED
    },
    checkboxOptions() {
      return this.departmentOptions.map(department => ({
        text: department.name,
        value: department.id
      }))
    }
  },
  methods: {
    onChangeScope(scope) {
      const isAllDepartments = scope === SCOPE_ALL
      this.$emit('update:isAllDepartments', isAllDepartments)
      // 「すべてのグループ」と個別グループは併用しない（API へは departments: [] を送る）
      if (isAllDepartments) this.$emit('update:departments', [])
    },
    onChangeDepartments(departments) {
      this.$emit('update:isAllDepartments', false)
      this.$emit('update:departments', departments)
    }
  }
}
</script>

<style lang="scss" scoped>
// bootstrap-vue のチェックボックス1行分の高さ（.custom-control の min-height: 1.5rem）
$checkbox-row-height: 24px;
$checkbox-row-gap: 4px;
$visible-rows: 6;

.note-template-department-select {
  &__lock-message {
    margin-top: 6px;
    color: $grey08;
  }

  &__departments {
    margin-top: 4px;
    margin-left: 24px;
    padding: 12px 14px;
    border: 1px solid $grey10;
    border-radius: 4px;
    background-color: $grey07;
  }

  &__checkboxes {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: $checkbox-row-gap 16px;
    // グループ数が多いテナントでフォームが縦に伸びすぎないよう6行分で打ち切ってスクロールさせる
    max-height: $checkbox-row-height * $visible-rows + $checkbox-row-gap * ($visible-rows - 1);
    overflow-y: auto;
  }
}
</style>
